export const defaultMarkTheme = {
    symbol: {
        shape: "circle",
        size: 8
    },
    text: {
        fontSize: 14,
        fill: "#000000"
    }
};
//# sourceMappingURL=mark.js.map
